export enum CameraMode {
  MODE_3D = '3d',
  MODE_2DH = '2dh',
  MODE_2DV = '2dv',
}
